module.exports = __webpack_public_path__ + "img/decorate.deeb9bed.png";